import { render, staticRenderFns } from "./BaseFormControl.vue?vue&type=template&id=67bb842c&"
import script from "./BaseFormControl.vue?vue&type=script&lang=js&"
export * from "./BaseFormControl.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports